/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FormattedNumber } from 'react-intl';
import axios from 'axios';
import { getAuthToken } from 'Api';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import classnames from 'classnames';
import Modal from 'Utils/Modal';
import CurrencyInput from 'Utils/CurrencyInput';
import { toNumber } from 'HelperFunctions/general';
import validations from 'HelperFunctions/validations';
import Radio from 'Utils/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropayBankForm from 'Components/profile/bankAccounts/PropayBankForm';
import WorldpayBankForm from 'Components/profile/bankAccounts/WorldpayBankForm';
import WorldpayHostedPaymentModal from 'Components/profile/creditCards/WorldpayHostedPaymentModal';
import StripeSecureCardModal from 'Components/profile/creditCards/StripeSecureCardModal';
import StandardSelectField from 'Utils/redux_form_inputs/StandardSelectField';
import { MakeAPayment } from 'Utils/SvgIcons';
import { collectStripeBankAccount } from 'Utils/collectStripeBankAccount';
import ScrollArea from 'Utils/react-scrollbar';
import CurrencyLabel from 'Utils/CurrencyLabel';
import { Close } from '../utils/SvgIcons';
import SurchargeNotice from 'Components/cart/SurchargeNotice';

class ConnectPaymentBox extends React.Component {
  state = {
    paymentSelection: 'credit_card',
    open: false,
    successOpen: false,
    successRefundOpen: false,
    errors: {},
    loading: false,
    billingStatus: '',
    transaction: {
      amount: '',
      payment_type: 'credit_card',
      payment_date: new Date(),
      card_token: '',
      bank_token: '',
      check_number: '',
    },
    removedBankAccountIds: [],
    new_card: null,
    new_bank: null,
    amountType: '',
    customAmount: '',
    linkToken: null,
    worldpayModalOpen: false,
    stripeModalOpen: false,
    cardNickname: '',
  };

  componentDidMount() {
    const { rental } = this.props;
    let amountType;
    if (!rental.hasDeposit) {
      amountType = 'amountDue';
    } else {
      amountType = rental.amountRemaining > 0 ? 'amountRemaining' : '';
    }
    this.setState(
      {
        amountType,
        customAmount: this.getPaymentAmount(amountType),
      },
      this.fetchLinkToken
    );
  }

  fetchLinkToken = () => {
    const { customer } = this.props;
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/api/create_link_token`, {
        customer_id: customer.id,
      })
      .then((response) => {
        this.setState({ linkToken: response.data.link_token });
      })
      .catch((error) => {
        console.error('Failed to fetch link token:', error);
      });
  };

  componentWillReceiveProps(nextProps) {
    const { rental } = nextProps;
    if (
      rental.hasDeposit !== this.props.rental.hasDeposit ||
      rental.amountRemaining !== this.props.rental.amountRemaining
    ) {
      let amountType;
      if (!rental.hasDeposit) {
        amountType = 'amountDue';
      } else {
        amountType = rental.amountRemaining > 0 ? 'amountRemaining' : '';
      }
      this.setState({
        amountType,
        customAmount: this.getPaymentAmount(amountType),
      });
    }
  }

  handleRemoveBank = (bankAccountId) => {
    const { customer } = this.props;
    axios
      .delete(
        `${process.env.REACT_APP_API_DOMAIN}/api/portal/bank_accounts/${bankAccountId}`,
        { headers: getAuthToken() }
      )
      .then(() => {
        // mark it removed in local state
        this.setState((state) => ({
          removedBankAccountIds: [
            ...state.removedBankAccountIds,
            bankAccountId,
          ],
        }));
      })
      .catch((err) => {
        console.error('Failed to remove bank account:', err);
      });
  };

  validate = () => {
    const errors = {};
    const amountDue = this.props.rental.amountRemaining;
    const { paymentSelection, transaction, customAmount } = this.state;

    if (
      paymentSelection === 'credit_card' &&
      validations.required(transaction.card_token, true)
    ) {
      errors.body = 'Please select a credit card.';
    }
    if (
      paymentSelection === 'bank' &&
      (
        validations.required(transaction.bank_token, true) ||
        transaction.bank_token === 'select_a_bank'
      )
    ) {
      errors.body = 'Please select a bank account.';
    }
    if (customAmount > amountDue || customAmount < 0) {
      errors.body = 'The Custom Amount you entered is invalid!';
    }

    return errors;
  };

  isOnlyLetters = (str) => {
    let strWithoutSpaces = str.replace(/\s/g, '');
    return /^[a-zA-Z]+$/.test(strWithoutSpaces);
  };

  isOnlyNumbers = (str) => {
    let strWithoutSpaces = str.replace(/\s/g, '');
    return /^\d+$/.test(strWithoutSpaces);
  };

  validateMerchantAccount = (location, paymentProcessor) => {
    const error = {};
    if (location.isOnTrial) {
      error.merchantAccount = 'Location is on trial and cannot accept payments';
    }
    if (paymentProcessor === 'stripe' && !location.hasStripeAuthentication) {
      error.merchantAccount = 'Merchant account is not setup for Stripe';
    }
    if (paymentProcessor === 'propay' && !location.hasPropayAuthentication) {
      error.merchantAccount = 'Merchant account is not setup for Propay';
    }
    if (
      (paymentProcessor === 'worldpay' || paymentProcessor === 'launchpay') &&
      !location.hasWorldpayAuthentication
    ) {
      error.merchantAccount = 'Merchant account is not setup.';
    }
    return error;
  };

  validateTransactionAmountAndType = (transaction, amount) => {
    const error = {};
    const { payment_type } = transaction;
    const cardTypes = ['new_credit_card', 'credit_card'];
    const bankTypes = ['new_bank', 'bank'];
    if (amount <= 0) {
      error.noAmount = 'Charge amount must be greater than 0.';
    }
    if (cardTypes.includes(payment_type) && amount < 0.5) {
      error.amount = 'The minimum charge is $0.50';
    } else if (bankTypes.includes(payment_type) && amount < 1.5) {
      error.amount = 'The minimum bank charge is $1.50.';
    }
    return error;
  };

  validateNewBank = (newBank) => {
    // Skip Propay/Worldpay bank validation when using GrailPay
    if (this.props.location.hasGrailpayEnabled) {
      return {};
    }

    const errors = {};
    const { account_number, bank_number, first_name, last_name } = newBank;
    if (!account_number) {
      errors.accountNumber = 'Account number cannot be blank.';
    }
    if (!this.isOnlyNumbers(account_number)) {
      errors.accountNumber = 'Account number must contain only numbers.';
    }
    if (!bank_number) {
      errors.bankNumber = 'Routing number cannot be blank.';
    }
    if (!this.isOnlyNumbers(bank_number)) {
      errors.notNumber = 'Routing number must contain only numbers.';
    }
    if (bank_number.length !== 9) {
      errors.bankNumber = 'Routing number must be 9 digits.';
    }
    if (!this.isOnlyLetters(first_name) || !this.isOnlyLetters(last_name)) {
      errors.accountName = 'Account name must be letters only.';
    }
    return errors;
  };

  validatePayments = (transaction, location, paymentProcessor) => {
    const error = {};
    const { payment_type } = transaction;
    const { hasWorldpayAuthentication } = location;
    const types = ['credit_card', 'new_credit_card'];
    if (
      types.includes(payment_type) &&
      !hasWorldpayAuthentication &&
      (paymentProcessor === 'worldpay' || paymentProcessor === 'launchpay')
    ) {
      error.paymentError = `This business isn't ready to accept ${paymentProcessor} payments.`;
    }
    if (payment_type === 'new_bank' && !hasWorldpayAuthentication) {
      error.paymentError = "This business isn't ready to accept bank payments.";
    }
    return error;
  };

  validateCardType = (cardType) => {
    const error = {};
    if (cardType === 'Select Card Type') {
      error.cardType = 'A card type must be selected.';
    }
    return error;
  };

  validateCardSelection = (cardSelected) => {
    const error = {};
    if (cardSelected === 'Select a Credit Card') {
      error.cardSelected = 'Please select a card.';
    }
    return error;
  };

  validateBankSelection = (bankSelected) => {
    const error = {};
    if (bankSelected === 'Select a Bank Account') {
      error.bankSelected = 'Please select a bank account';
    }
    return error;
  };

  validateBankType = (paymentMethodType, checkType, companyName) => {
    const error = {};
    if (paymentMethodType === 'Select Payment Method Type') {
      error.bankType = 'You must select an account type.';
    }
    if (checkType === 'Check Type') {
      error.checkType = 'You must select a check type';
    }
    if (checkType === 'Business' && !companyName) {
      error.companyName = 'Please enter a Company name';
    }
    return error;
  };

  buildRailsObject = () => {
    const { location, customer, rental } = this.props;
    const { transaction, new_card, new_bank, amountType } = this.state;

    let payment_type;
    if (transaction.payment_type === 'credit_card') {
      payment_type =
        transaction.card_token === 'new_credit_card'
          ? 'new_credit_card'
          : 'credit_card';
    } else {
      payment_type = transaction.bank_token.startsWith('new_bank')
        ? 'new_bank'
        : 'bank';
    }

    const newTransaction = {
      ...transaction,
      customer_id: customer.id,
      amount: this.getPaymentAmount(amountType),
      payment_source: 'cp',
      payment_type,
    };

    return {
      location_id: location.id,
      transaction: newTransaction,
      billing_note: {
        author_name: `${customer.firstName} ${customer.lastName}`,
        message: 'From Storefront',
        note_type: 'Payment',
      },
      new_card,
      new_bank,
      send_receipt: true,
    };
  };

  toggleWorldpayModal = () => {
    this.setState((prev) => ({ worldpayModalOpen: !prev.worldpayModalOpen }));
  };

  toggleStripeModal = () => {
    this.setState((prev) => ({ stripeModalOpen: !prev.stripeModalOpen }));
  };

  handleWorldpayCardSaved = (savedCard) => {
    // Refresh customer data to get the new card
    const { location, fetchProfile } = this.props;
    if (fetchProfile) {
      fetchProfile(location.id);
    }

    // Set the new card as selected
    const cardToken = savedCard.creditCard?.token || savedCard.token;
    if (cardToken) {
      const newTransaction = {
        ...this.state.transaction,
        card_token: cardToken,
      };
      this.setState({ transaction: newTransaction });
    }

    // Close the modal
    this.toggleWorldpayModal();
  };

  handleStripeCardSaved = (savedCard) => {
    const { location, fetchProfile } = this.props;
    if (fetchProfile) {
      fetchProfile(location.id);
    }
    const card =
      savedCard?.credit_card ??
      savedCard?.creditCard ??
      savedCard?.data ??
      savedCard;
    const cardToken =
      card?.token ?? card?.id ?? savedCard?.token ?? savedCard?.id;
    if (cardToken) {
      const newTransaction = {
        ...this.state.transaction,
        card_token: cardToken,
      };
      this.setState({ transaction: newTransaction });
    }
    this.toggleStripeModal();
  };

  handleSubmitNewPropayBank = (values) => {
    this.setState(
      {
        new_bank: values,
        transaction: {
          ...this.state.transaction,
          bank_token: 'new_bank_manual',
        },
      },
      this.handleSubmit
    );
  };

  handleSubmitNewBank = (token, metadata) => {
    // Plaid
    const new_bank = { token, account_id: metadata.account_id };
    this.setState(
      {
        new_bank,
        transaction: { ...this.state.transaction, bank_token: 'new_bank' },
      },
      this.handleSubmit
    );
  };

  // TD1-10212: Stripe SDK bank collection (us_bank_account + Financial Connections), replaces Plaid.
  handleStripeBankClick = async () => {
    const { customer, rental, location, openLoadingSpinner, closeLoadingSpinner, setErrors } =
      this.props;
    try {
      openLoadingSpinner('Connecting your bank...');
      const paymentMethodId = await collectStripeBankAccount({
        rentalToken: rental.token,
        locationId: location.id,
        customerId: customer.id,
        billingDetails: {
          name: `${customer.firstName || ''} ${customer.lastName || ''}`.trim(),
          email: customer.email,
        },
      });
      closeLoadingSpinner();
      this.handleSubmitNewBankStripe(paymentMethodId);
    } catch (error) {
      closeLoadingSpinner();
      setErrors({ bank: error.message });
    }
  };

  handleSubmitNewBankStripe = (paymentMethodId) => {
    this.setState(
      {
        new_bank: { payment_method_id: paymentMethodId },
        transaction: { ...this.state.transaction, bank_token: 'new_bank' },
      },
      this.handleSubmit
    );
  };

  handleSubmit = () => {
    const { new_bank, transaction, customAmount, paymentSelection } =
      this.state;
    const {
      rental,
      location,
      openLoadingSpinner,
      closeLoadingSpinner,
      onPaymentSuccess,
    } = this.props;

    const errors = {
      ...this.validate(),
      ...this.validateMerchantAccount(location, rental.paymentProcessor),
      ...this.validateTransactionAmountAndType(transaction, customAmount),
      ...this.validatePayments(transaction, location, rental.paymentProcessor),
    };

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      this.props.setErrors(errors);
      return;
    }

    openLoadingSpinner(
      'Processing payment... Please do not refresh or navigate away from this page.'
    );
    axios
      .post(
        `${process.env.REACT_APP_API_DOMAIN}/api/portal/rentals/${rental.token}/transactions`,
        this.buildRailsObject(),
        { headers: getAuthToken() }
      )
      .then((response) => {
        closeLoadingSpinner();
        onPaymentSuccess(response.data.transaction);
        this.setState({
          open: false,
          transaction: {
            amount: '',
            payment_type: 'new_credit_card',
            payment_date: new Date(),
            card_token: '',
            bank_token: '',
            check_number: '',
          },
          new_card: null,
          new_bank: null,
          errors: {},
        });
      })
      .catch((error) => {
        closeLoadingSpinner();
        const respErrors = error.response?.data || {};
        this.props.setErrors(respErrors);
        this.setState({ errors: respErrors });
      });
  };

  handleSuccessClose = () => {
    this.setState({ successOpen: false });
  };

  handleTransactionChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      transaction: { ...this.state.transaction, [name]: value },
    });
  };

  handlePaymentAmountChange = (event) => {
    this.setState({ customAmount: event.target.value });
  };

  handlePaymentTypeChange = (event) => {
    const value = event.target.value;
    this.setState({
      paymentSelection: value,
      transaction: {
        ...this.state.transaction,
        payment_type: value,
        card_token: '',
        // if they switched to bank, preselect "new_bank"
        bank_token: value === 'bank' ? 'new_bank' : '',
      },
    });
  };


  handleAmountTypeChange = (event) => {
    const newAmountType = event.target.value;
    this.setState({
      amountType: newAmountType,
      customAmount: this.getPaymentAmount(newAmountType),
    });
  };

  getPaymentAmount = (amountType) => {
    const { rental } = this.props;
    const amountDue = rental.hasDeposit
      ? 0
      : Number(rental.minimumDeposit) - Number(rental.paymentBalance);
    switch (amountType) {
      case 'amountDue':
        return amountDue;
      case 'amountRemaining':
        return rental.amountRemaining;
      case 'custom':
        return this.state.customAmount;
      default:
        return 0;
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: toNumber(value) });
  };

  renderNewCreditCardSection() {
    const { location, customer, rental } = this.props;
    const { worldpayModalOpen, stripeModalOpen, cardNickname } = this.state;

    switch (rental.paymentProcessor) {
      case 'worldpay':
      case 'launchpay':
        return (
          <div>
            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="card-nickname" style={{ display: 'block', marginBottom: '5px', fontWeight: 'normal' }}>
                Nickname for Card (optional)
              </label>
              <input
                id="card-nickname"
                type="text"
                maxLength={10}
                placeholder="Nickname for Card (i.e., 'Work')"
                value={cardNickname}
                onChange={(e) => this.setState({ cardNickname: e.target.value })}
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px',
                }}
              />
            </div>
            <button
              type="button"
              className="btn full"
              onClick={this.toggleWorldpayModal}
              style={{ marginBottom: '15px' }}
            >
              Add Credit Card Securely
            </button>
            <WorldpayHostedPaymentModal
              open={worldpayModalOpen}
              toggle={this.toggleWorldpayModal}
              title="Add Credit Card"
              location={location}
              customerId={customer.id}
              customerType="Customer"
              nickname={cardNickname}
              onCardSaved={this.handleWorldpayCardSaved}
              onError={(error) => {
                this.props.setErrors({ body: error });
              }}
            />
            <p style={{ marginTop: '15px', marginBottom: '15px' }}>
              By clicking &quot;Add Credit Card Securely,&quot; you authorize us to securely store your encrypted payment card on
              file for future charges and orders.
            </p>
          </div>
        );
      case 'stripe':
        return (
          <div>
            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="card-nickname-stripe" style={{ display: 'block', marginBottom: '5px', fontWeight: 'normal' }}>
                Nickname for Card (optional)
              </label>
              <input
                id="card-nickname-stripe"
                type="text"
                maxLength={10}
                placeholder="Nickname for Card (i.e., 'Work')"
                value={cardNickname}
                onChange={(e) => this.setState({ cardNickname: e.target.value })}
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px',
                }}
              />
            </div>
            <button
              type="button"
              className="btn full"
              onClick={this.toggleStripeModal}
              style={{ marginBottom: '15px' }}
            >
              Add Credit Card Securely
            </button>
            <StripeSecureCardModal
              open={stripeModalOpen}
              toggle={this.toggleStripeModal}
              title="Add Credit Card"
              location={location}
              nickname={cardNickname}
              onCardSaved={this.handleStripeCardSaved}
              onError={(error) => {
                this.props.setErrors({ body: error });
              }}
            />
            <p style={{ marginTop: '15px', marginBottom: '15px' }}>
              By clicking &quot;Add Credit Card Securely,&quot; you authorize us to securely store your encrypted payment card on
              file for future charges and orders.
            </p>
          </div>
        );
      default:
        return null;
    }
  }

  getSurchargeAmount = () => {
    const { paymentSelection, transaction, amountType } = this.state;
    const { location, customer, creditCardPercent, rental } = this.props;
    if (paymentSelection !== 'credit_card' || !location.chargeCreditCardFee || !rental?.rentalSetting?.applyCcFee || creditCardPercent <= 0) {
      return 0;
    }
    const isCardSelected = transaction.card_token
      && transaction.card_token !== 'new_credit_card';
    let isCreditBinType = true;
    if (isCardSelected) {
      const selectedCard = this.availableStorefrontCreditCards().find((cc) => cc.token === transaction.card_token);
      if (selectedCard) {
        isCreditBinType = selectedCard.binType === 'credit';
      }
    }
    if (!isCreditBinType) return 0;
    const amount = Number(this.getPaymentAmount(amountType)) || 0;
    return (creditCardPercent / 100) * amount;
  };

  isPropayInUSA = (rental, location) =>
    rental.paymentProcessor === 'propay' && location.propayCountry === 'USA';

  handleEditAmount = () => {
    const { location } = this.props;
    this.setState({
      transaction: {
        ...this.state.transaction,
        card_token: '',
        bank_token: location.hasGrailpayEnabled ? 'select_a_bank' : 'new_bank',
      },
    });
  };

  availableStorefrontCreditCards = () => {
    const { customer, rental } = this.props;
    const rentalPaymentProcessor = rental.paymentProcessor;
    const processorMatchedCards = (customer.creditCards || []).filter((card) => {
      const processorMatches =
        (rentalPaymentProcessor === 'launchpay' && card.paymentProcessor === 'worldpay') ||
        card.paymentProcessor === rentalPaymentProcessor;

      return processorMatches;
    });

    const hasAddedViaData = processorMatchedCards.some((card) => card.addedVia != null);
    if (!hasAddedViaData) return processorMatchedCards;

    return processorMatchedCards.filter((card) => card.addedVia === 'storefront');
  };

  render() {
    const {
      errors,
      paymentSelection,
      customAmount,
      amountType,
      transaction,
      linkToken,
      removedBankAccountIds,
    } = this.state;
    const { location, customer, rental, creditCardPercent } = this.props;
    const availableStorefrontCreditCards = this.availableStorefrontCreditCards();

    const savedBankAccounts = customer.bankAccounts
      .filter((ba) => !removedBankAccountIds.includes(ba.id))
      .filter((ba) => {
        const rentalPaymentProcessor = rental.paymentProcessor;
        const bankAccountPaymentProcessor = ba.paymentProcessor;

        // 1. Stripe rentals only ever get Stripe Bank Accounts
        if (rentalPaymentProcessor === 'stripe') {
          return bankAccountPaymentProcessor === 'stripe';
        }

        // 2. Launchpay rentals...
        if (rentalPaymentProcessor === 'launchpay') {
          // 2a. …before Grailpay-switch keep only Launchpay Bank Accounts
          if (!location.hasGrailpayEnabled) {
            return bankAccountPaymentProcessor === 'launchpay';
          }
          // 2b. …after Grailpay-switch keep only Grailpay Bank Accounts
          return bankAccountPaymentProcessor === 'grailpay';
        }

        // 3. Everything else: no Bank Accounts
        return false;
      });

    return (
      <section className='connectPaymentBox'>
        <div className='summary'>
          <MakeAPayment />
          <h4>{rental.locationName}</h4>
          <div className='billingDetails'>
            {!rental.hasDeposit && rental.minimumDeposit !== '' && (
              <div>
                <label>Minimum Deposit</label>
                <CurrencyLabel
                  value={
                    Number(rental.minimumDeposit) -
                    Number(rental.paymentBalance)
                  }
                />
              </div>
            )}
            {(() => {
              const showSurcharge = paymentSelection === 'credit_card'
                && location.chargeCreditCardFee
                && rental?.rentalSetting?.applyCcFee
                && creditCardPercent > 0;
              const surchargeAmount = this.getSurchargeAmount();
              const isCardSelected = transaction.card_token
                && transaction.card_token !== 'new_credit_card';
              const isConfirmedDebit = isCardSelected && surchargeAmount === 0;
              const hasSurchargeRows = showSurcharge && !isConfirmedDebit;
              return (
                <>
                  <div>
                    <label>{hasSurchargeRows ? 'Payment Subtotal' : 'Payment Total'}</label>
                    <CurrencyLabel value={this.getPaymentAmount(amountType)} />
                  </div>
                  {hasSurchargeRows && (
                    <>
                      <div>
                        <label>{isCardSelected ? 'CC Surcharge' : 'CC Surcharge Estimate'}</label>
                        <span>{!isCardSelected && '~'}<CurrencyLabel value={surchargeAmount} /></span>
                      </div>
                      <div style={{ borderTop: '2px solid currentColor', paddingTop: '5px' }}>
                        <label>Payment Total</label>
                        <CurrencyLabel value={(Number(this.getPaymentAmount(amountType)) || 0) + surchargeAmount} />
                      </div>
                    </>
                  )}
                </>
              );
            })()}
          </div>
          {rental?.rentalSetting?.applyCcFee && (
            <div className='desktopSurchargeNotice' style={{ marginTop: '40px' }}>
              <SurchargeNotice kind="action" />
            </div>
          )}
        </div>

        <ScrollArea speed={0.8} horizontal={false}>
          <div className='details'>
            {/* Amount Selection */}
            <div className='fields amount'>
              <label>Payment Amount</label>
              {(() => {
                const bankMethodSelected =
                  paymentSelection === 'bank' &&
                  transaction.bank_token &&
                  !['new_bank', 'new_bank_manual', 'select_a_bank'].includes(
                    transaction.bank_token
                  );
                const paymentMethodSelected =
                  (paymentSelection === 'credit_card' &&
                    transaction.card_token &&
                    transaction.card_token !== 'new_credit_card') ||
                  bankMethodSelected;
                const currentAmount = this.getPaymentAmount(amountType);
                if (paymentMethodSelected) {
                  return (
                    <p style={{ margin: 0 }}>
                      Pay: <CurrencyLabel value={currentAmount} />{' '}
                      <a
                        href='#'
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleEditAmount();
                        }}
                        style={{ color: '#007cba', textDecoration: 'underline' }}
                      >
                        Edit
                      </a>
                    </p>
                  );
                }
                return (
                  <>
                    <RadioGroup
                      name='amountType'
                      className='radioList'
                      value={amountType}
                      onChange={this.handleAmountTypeChange}
                    >
                      <FormControlLabel
                        label='Amount Due'
                        value='amountRemaining'
                        control={<Radio />}
                      />
                      <FormControlLabel
                        label='Minimum Deposit to Reserve'
                        value='amountDue'
                        control={<Radio />}
                      />
                      <FormControlLabel
                        label='Custom Amount'
                        value='custom'
                        control={<Radio />}
                      />
                    </RadioGroup>
                    <strong>
                      <CurrencyLabel
                        value={this.getPaymentAmount('amountRemaining')}
                      />
                    </strong>
                    <strong>
                      <CurrencyLabel value={this.getPaymentAmount('amountDue')} />
                    </strong>
                    <CurrencyInput
                      name='customAmount'
                      type='text'
                      placeholder='0.00'
                      className={classnames({ med: true, error: errors.amount })}
                      value={customAmount}
                      onChange={this.handleChange}
                    />
                  </>
                );
              })()}
            </div>

            {/* Method of Payment */}
            <div className='fields'>
              <label>Method of Payment</label>
              <div className='paymentMethodRow'>
                <RadioGroup
                  name='paymentType'
                  className='radioList'
                  onChange={this.handlePaymentTypeChange}
                  value={paymentSelection}
                  style={{ flex: 'none' }}
                >
                  <FormControlLabel
                    value='credit_card'
                    control={<Radio />}
                    label='Credit Card'
                  />
                  {(rental.paymentProcessor === 'stripe' || location.hasGrailpayEnabled) && (
                    <FormControlLabel
                      value='bank'
                      control={<Radio />}
                      label='Bank Account'
                    />
                  )}
                </RadioGroup>
                {location.chargeCreditCardFee && rental?.rentalSetting?.applyCcFee && creditCardPercent > 0 && paymentSelection === 'credit_card' && (() => {
                  const surchargeAmount = this.getSurchargeAmount();
                  const isCardSelected = transaction.card_token
                    && transaction.card_token !== 'new_credit_card';
                  if (isCardSelected && surchargeAmount === 0) return null;
                  return (
                    <span className='paymentSurchargeHint'>
                      (+<CurrencyLabel value={surchargeAmount} /> {isCardSelected ? 'Surcharge' : 'Estimated Surcharge'})
                    </span>
                  );
                })()}
              </div>
            </div>

            {/* Pay With */}
            <div className='fields'>
              <label>Pay Using</label>
              {paymentSelection === 'credit_card' && (
                <StandardSelectField
                  meta={{}}
                  input={{
                    name: 'card_token',
                    value: transaction.card_token,
                    onChange: this.handleTransactionChange,
                  }}
                >
                  <option value=''>Select a Credit Card</option>
                  <option value='new_credit_card'>New Credit Card</option>
                  {availableStorefrontCreditCards.map((credit_card) => (
                      <option key={credit_card.id} value={credit_card.token}>
                        {credit_card.name}
                      </option>
                    ))}
                </StandardSelectField>
              )}
              {transaction.card_token === 'new_credit_card' && this.renderNewCreditCardSection()}

              {paymentSelection === 'bank' && (
                <>
                  <StandardSelectField
                    meta={{}}
                    input={{
                      name: 'bank_token',
                      value: transaction.bank_token,
                      onChange: this.handleTransactionChange,
                    }}
                  >
                    {location.hasGrailpayEnabled ? (
                      <>
                        <option value='select_a_bank'>Select a Bank</option>
                        <option value='new_bank_manual'>
                          Bank Routing and Account Number
                        </option>
                        {savedBankAccounts.map((bankAccount) => (
                          <option
                            key={bankAccount.id}
                            value={bankAccount.token}
                          >
                            ****{bankAccount.bankInfo.last4}
                          </option>
                        ))}
                      </>
                    ) : (
                      <>
                        <option value='new_bank'>New Bank Account</option>
                      </>
                    )}
                  </StandardSelectField>

                  {location.hasGrailpayEnabled &&
                    savedBankAccounts.length > 0 && (
                      <details className='saved-accounts-dropdown'>
                        <summary>
                          Manage Saved Bank Accounts ({savedBankAccounts.length}
                          )
                        </summary>
                        <ul className='saved-account-list'>
                          {savedBankAccounts.map((ba) => (
                            <li key={ba.id} className='saved-account-item'>
                              <span>****{ba.bankInfo.last4}</span>
                              <div
                                role='button'
                                onClick={() => this.handleRemoveBank(ba.id)}
                              >
                                <Close />
                              </div>
                            </li>
                          ))}
                        </ul>
                      </details>
                    )}
                </>
              )}

              {/* Stripe bank collection (us_bank_account + Financial Connections) */}
              {paymentSelection === 'bank' &&
                transaction.bank_token === 'new_bank' &&
                rental.paymentProcessor === 'stripe' && (
                  <a className='btn full' onClick={this.handleStripeBankClick}>
                    Pay with Bank Account
                  </a>
                )}

              {/* Manual Worldpay/Propay Form */}
              {paymentSelection === 'bank' &&
                (transaction.bank_token === 'new_bank_manual' ||
                  (!location.hasGrailpayEnabled &&
                    transaction.bank_token === 'new_bank')) &&
                (rental.paymentProcessor === 'worldpay' ||
                  rental.paymentProcessor === 'launchpay') && (
                  <WorldpayBankForm
                    onSubmit={this.handleSubmitNewPropayBank}
                    type='checkout'
                  />
                )}

              {/* Submit Button for Saved Methods */}

              {((paymentSelection === 'credit_card' &&
                transaction.card_token !== 'new_credit_card') ||
                (paymentSelection === 'bank' &&
                  !['new_bank', 'new_bank_manual', 'select_a_bank'].includes(
                    transaction.bank_token
                  ))) && (
                  <>
                    {paymentSelection === 'credit_card' && (
                      <p style={{ marginTop: '15px', marginBottom: '15px' }}>
                         By clicking “Make Payment,” you authorize us to securely
                         store your encrypted payment card on file for future charges and orders.
                      </p>
                    )}
                    <div className='actions'>
                      <button
                        type='button'
                        onClick={this.handleSubmit}
                        className='btn full'
                      >
                        {(() => {
                          const amount = Number(this.getPaymentAmount(amountType)) || 0;
                          const total = amount + this.getSurchargeAmount();
                          return <>Submit Payment of <CurrencyLabel value={total} /></>;
                        })()}
                      </button>
                    </div>
                  </>
                )}
            </div>
            {rental?.rentalSetting?.applyCcFee && (
              <div className='mobileSurchargeNotice'>
                <SurchargeNotice kind="action" />
              </div>
            )}
          </div>
        </ScrollArea>

        <Modal
          open={this.state.successOpen}
          toggle={this.handleSuccessClose}
          title='Payment Confirmation'
          actions={[
            <a className='btn full' onClick={this.handleSuccessClose}>
              Ok
            </a>,
          ]}
        >
          <p>Submitted payment was received</p>
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const location = ownProps.location || state.locations.location;
  const customer = ownProps.customer || state.customer.customer;
  return {
    creditCardPercent: location.creditCardPercent,
    location,
    customer,
  };
};

export default connect(mapStateToProps, actions)(ConnectPaymentBox);
